import React from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../components/layout/PublicHeader';
import PublicFooter from '../components/layout/PublicFooter';

const LandingPage: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-slate-50">
      {/* Header */}
      <PublicHeader />

      {/* Main Content */}
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="bg-white py-16 border-b border-slate-100">
          <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div className="text-center md:text-right">
              <h1 className="text-4xl font-bold text-slate-900 mb-4">
                آزمایشگاه تشخیص طبی، آسیب شناسی و ژنتیک رازی رشت
              </h1>
              <p className="text-xl text-slate-600 mb-8">
                ارائه خدمات آزمایشگاهی با بالاترین کیفیت و دقت
              </p>
              <div className="flex flex-wrap gap-4 justify-center md:justify-start">
                <Link to="/home" className="px-6 py-3 bg-blue-600 text-white hover:bg-blue-700 rounded-lg text-lg font-medium">
                  ثبت درخواست آزمایش
                </Link>
                <Link to="/guide" className="px-6 py-3 bg-white text-blue-600 border border-blue-600 hover:bg-blue-50 rounded-lg text-lg font-medium">
                  راهنمای درخواست
                </Link>
              </div>
            </div>
            <div className="flex justify-center">
              <img src="/assets/img/1.jpg" alt="آزمایشگاه رازی" className="max-h-80" />
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center mb-12">خدمات آزمایشگاه رازی</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white p-6 rounded-lg shadow-sm border border-slate-200 text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <img src="/assets/img/rocket.png" alt="" className="h-8 w-8" />
                </div>
                <h3 className="text-xl font-bold mb-3">سرعت بالا</h3>
                <p className="text-slate-600">دریافت نتایج آزمایش در کوتاه‌ترین زمان ممکن</p>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow-sm border border-slate-200 text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <img src="/assets/img/bolt.png" alt="" className="h-8 w-8" />
                </div>
                <h3 className="text-xl font-bold mb-3">دقت بالا</h3>
                <p className="text-slate-600">استفاده از تجهیزات پیشرفته برای نتایج دقیق</p>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow-sm border border-slate-200 text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-3">اطمینان</h3>
                <p className="text-slate-600">با اطمینان خاطر نتایج آزمایش خود را دریافت کنید</p>
              </div>
            </div>
          </div>
        </section>
        
        {/* Contact Info */}
        <section className="bg-white py-16 border-t border-slate-100">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center mb-12">اطلاعات تماس</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-3">تلفن تماس</h3>
                <p className="text-slate-600 mb-1">3401-013</p>
                <p className="text-slate-600">خدمات غیرحضوری: 32312094-013</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-3">پست الکترونیک</h3>
                <p className="text-slate-600">info@razipath.net</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-3">آدرس</h3>
                <p className="text-slate-600">رشت، استان گیلان</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <PublicFooter />
    </div>
  );
};

export default LandingPage; 